module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "mainapp"
    }
  }, [_c('div', {
    staticClass: "left-scroll",
    attrs: {
      "id": "left"
    }
  }, [_c('h1', {
    attrs: {
      "id": "logo"
    }
  }, [_vm._v("Bone4")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "logo-tiny"
    }
  }, [_vm._v("Vue 2.0 version")]), _vm._v(" "), _c('sidebar-menu', {
    ref: "mains",
    attrs: {
      "surface": [{
        alias: 'base',
        title: '基 础',
        sub: 'base'
      }, {
        alias: 'form',
        title: '输 入',
        sub: 'form'
      }, {
        alias: 'list',
        title: '列表&菜单',
        sub: 'list'
      }, {
        alias: 'message',
        title: '信息提示',
        sub: 'message'
      }, {
        alias: 'other',
        title: '其 他',
        sub: 'other'
      }],
      "size": "sm",
      "current": _vm.currentCategory
    },
    on: {
      "on-click": _vm.handleSidebar
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "frame"
    }
  }, [_c('div', {
    staticClass: "left-scroll",
    attrs: {
      "id": "child-left"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSub),
      expression: "showSub"
    }]
  }, [_c('sidebar-menu', {
    ref: "sub",
    attrs: {
      "surface": _vm.subSurface,
      "size": "sm",
      "theme": "white",
      "current": _vm.currentComponent
    },
    on: {
      "on-click": _vm.handleSubbar
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "thin-scroll",
    attrs: {
      "id": "child-mid"
    }
  }, [_c('div', {
    staticClass: "mobile",
    staticStyle: {
      "width": "330px",
      "height": "560px",
      "margin": "0 auto"
    }
  }, [_c('div', {
    staticClass: "screen",
    staticStyle: {
      "background": "#f2f2f2",
      "overflow": "hidden",
      "height": "470px"
    }
  }, [_c('iframe', {
    staticClass: "thin-scroll",
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "src": '#/mobile/demo/' + _vm.currentComponent,
      "width": "320",
      "height": "470"
    }
  })])])]), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "child-right"
    }
  }, [_c('div', {
    staticClass: "markdown",
    attrs: {
      "id": "content"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-83389220!./~/vue-loader/lib/selector.js?type=template&index=0!./src/home/app.vue
// module id = 273
// module chunks = 36